import React, { Component } from 'react';
import { Button } from '../../elements/buttons/Button';
import { Row, Col } from 'reactstrap';
import { convertDateToFirestoreTimestamp } from '../../../firebase/api/firestoreUtils';
import { getUserUid } from '../../../static/localStorage';
import './CreatePostReview.css';
import { HideQuestionButtonIcon } from '../../elements/icons/Icons';
import { MAX_REVIEW_DESCRIPTION_LENGTH } from '../../../constants/questions';
import AddCardModal from '../../elements/addCardModal';

const initialDTO = {
    publisherUid: '',
    postUid: '',
    questions: [],
    text: '',
    createdTimestamp: null,
    minDonation: 0,
    donation: 0,
};

class CreatePostReview extends Component {
    state = {
        showReviewForm: false,
        question: [],
        post: null,
        createReviewDTO: { ...initialDTO },
        showAddCardModal: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.question !== nextProps.question || prevState.post !== nextProps.post) {
            return {
                question: nextProps.question,
                post: nextProps.post,
            };
        }

        if (prevState.showReviewForm !== nextProps.showReviewForm) {
            return {
                showReviewForm: nextProps.showReviewForm,
            };
        }
        return null;
    }

    cardCheck = () => {
        const { authUser } = this.props;
        if (authUser) {
            this.onClickPublish();
        } else {
            this.cardModalToggle();
        }
    };

    onClickPublish = () => {
        const createReviewDTO = { ...this.state.createReviewDTO };
        this.prepareDefaultMetadata(createReviewDTO);
        this.props.onPublishReview(createReviewDTO, () => {
            createReviewDTO.questions.splice(0, createReviewDTO.questions.length);
            this.setState({ createReviewDTO: initialDTO });
        });
    };

    prepareDefaultMetadata = dto => {
        const { post, question } = this.state;
        dto.publisherUid = getUserUid();
        dto.createdTimestamp = convertDateToFirestoreTimestamp(new Date());
        dto.postUid = post.uid;
        question.map(question =>
            dto.questions.push({
                order: question.order,
                title: question.title,
                uid: question.uid,
            })
        );
        dto.postOwnerUid = post.publisherUid;
    };

    onInputChange = (event, length) => {
        if (!length || event.target.value.length < length) {
            const createReviewDTO = { ...this.state.createReviewDTO };
            createReviewDTO[event.target.name] = event.target.value;
            this.setState({ createReviewDTO });
        }
    };

    cardModalToggle = () => {
        this.setState(prevState => ({
            showAddCardModal: !prevState.showAddCardModal,
        }));
    };

    render() {
        const { createReviewDTO, showReviewForm, showAddCardModal } = this.state;
        const { hideReviewForm } = this.props;
        return (
            <div>
                {showReviewForm && (
                    <div className="PostReview">
                        <div className="form-group">
                            <textarea
                                name="text"
                                rows={4}
                                className="form-control"
                                placeholder="Review"
                                value={createReviewDTO.text}
                                onChange={event =>
                                    this.onInputChange(event, MAX_REVIEW_DESCRIPTION_LENGTH)
                                }
                            />
                        </div>
                        <div className="form-group">
                            <Row className="PostReviewDonate">
                                {/*<Col md={3}>*/}
                                {/*    <p>Minimum donation:</p>*/}
                                {/*</Col>*/}
                                {/*<Col md={4}>*/}
                                {/*    <input*/}
                                {/*        name="minDonation"*/}
                                {/*        type="number"*/}
                                {/*        className="form-control"*/}
                                {/*        placeholder="Min donation"*/}
                                {/*        value={createReviewDTO.minDonation}*/}
                                {/*        onChange={this.onInputChange}*/}
                                {/*    />*/}
                                {/*</Col>*/}
                                <Col md={7} />
                                <Col md={5}>
                                    <Button
                                        classes="btn btn-outline-primary"
                                        title="Publish"
                                        onClick={() => this.cardCheck()}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="w-100 justify-content-center">
                            <div className="hide-question-button" onClick={() => hideReviewForm()}>
                                <HideQuestionButtonIcon />
                            </div>
                        </div>
                    </div>
                )}
                {showAddCardModal && (
                    <AddCardModal modal={showAddCardModal} toggle={this.cardModalToggle} />
                )}
            </div>
        );
    }
}

export default CreatePostReview;
